import { AdBasic } from './AdBasic'
import { AdFixed } from './AdFixed'
import { AdPopUp } from './adPopUp'

import { STATUS_ERROR, URL_BASE, _DESKTOP_, _MOVIL_, movilMaxWidth, AdParam, AD_TYPE } from './contanst'

class FactoryBase {
  constructor (lazy = true) {
    this.lazy = lazy

    this.setScreen()
    this.ads = null
  }

  setScreen () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < movilMaxWidth) {
      this.screen = _MOVIL_
    } else {
      this.screen = _DESKTOP_
    }
  }

  get () {
    this.data.client = AdParam.client
    this.data.development = AdParam.development
    fetch(`${URL_BASE}${this.getMethod}`, {
      method: 'POST',
      body: JSON.stringify(this.data)
    }).then(r => r.json())
      .then(json => this.Response(json))
  }

  InitAds (data) {
    try {
      this.ads = this.Create(data)
      if (this.ads == null) {
        if (data.type != AD_TYPE.Multiple) {
          console.error('No se pudo crear el tipo de publiciad(' + Response.data.type + ')')
          console.error(Response.data.type + 'tipo no existente')
        }
        return
      }
      /* seteo el tipo de dispositivo en el cual estoy para su posterior uso */
      this.ads.setMedia(this.screen)

      /* creao la publicidad y lo pongo en pantalla */
      this.ads.create()
    } catch (e) {
      console.error(e)
    }
  }

  /**
       * devuelvo un objeto de publicidad dependiendo del tipo
       * @param  data
       * @returns {CAdBasic|CAdPopUp|CAdFixed}
       */
  Create (data) {
    let ad = null
    switch (parseInt(data.type)) {
      case AD_TYPE.Basic:
        ad = new AdBasic(data)
        break
      case AD_TYPE.PopUp:
        ad = new AdPopUp(data)
        break
      case AD_TYPE.Fixed:
        ad = new AdFixed(data)
        break
      case AD_TYPE.Multiple:
        data.containers.forEach(data => Object.keys(data.ads).length ? this.InitAds(data) : new FactoryAds(data.id, this.containerAds))
        break
    }
    return ad
  }
}

/*
 * class para la busqueda de la publicidad y construir segun su tipo
 * @param int identificador elemnto del html al que pertenece
 * @param int ContainerAd identificador del contenedor a publicidad a usar
 * @returns {CFactoryAds}
 */
export class FactoryAds extends FactoryBase {
  constructor (id, ContainerAds, quantity = 1, lazy = true) {
    super(lazy)
    this.screen = _DESKTOP_
    this.id = id
    this.containerAds = ContainerAds
    this.quantity = quantity
    this.data = {
      id: this.id,
      containerAds: this.containerAds,
      quantity: this.quantity,
      screen: this.screen,
      section: AdParam.section,
      lazy: this.lazy
    }
    this.getMethod = 'getAdContainer'
  }

  Response (Response) {
    if (Response.status == STATUS_ERROR) {
      console.error(Response.Message)
      return
    }
    this.InitAds(Response.data.ad)
  }
}

/*
 * class para la busqueda de la publicidad y construir segun su tipo
 * @param int identificador elemnto del html al que pertenece
 * @param int ContainerAd identificador del contenedor a publicidad a usar
 * @returns {CFactoryAds}
 */
export class FactoryAdsContainers extends FactoryBase {
  constructor (containers, lazy = true) {
    super(lazy)
    this.containers = containers
    this.data = {
      containers: Object.entries(this.containers).map(([key, container]) => (
        {
          id: container.length == 1 ? container[0] : container,
          containerAds: key,
          quantity: container.length,
          screen: this.screen,
          section: AdParam.section,
          lazy: this.lazy
        }
      ))
    }
    this.getMethod = 'getAdVariousContainer'
  }

  Response (Response) {
    if (Response.status == STATUS_ERROR) {
      console.error(Response.Message)
      return
    }

    for (const i in Response.data.containers) {
      this.InitAds(Response.data.containers[i])
    }
  }
}
